import React from 'react'
import Header from './components/header/header'
import Nav from './components/nav/nav'
import About from './components/About/about'
import Experience from './components/Experience/exp'
import Services from './components/services/services'
import Portfolio from './components/portfolio/portfolio'
import Testimonials from './components/testimonial/testimonial'
import Contact from './components/Contact/contact'
import Footer from './components/Footer/footer'
const App = () => {
  return (
    <div>
        <> 
        <Header />
        <Nav />
        <About />
        <Experience />
        <Services />
        <Portfolio />
        <Testimonials />
        <Contact />
        <Footer />
         </>
    </div>
  )
}

export default App